import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Menu, X } from 'lucide-react'

const links = [
  { to: '/features', label: 'Funktioner' },
  { to: '/pricing', label: 'Priser' },
  { to: '/om-os', label: 'Om os' },
]

export default function Navbar() {
  const [open, setOpen] = useState(false)

  return (
    <header className="bg-navy-950 text-white sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <NavLink to="/" className="text-xl font-semibold tracking-tight text-white">
          Boligflow
        </NavLink>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {links.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                isActive
                  ? 'text-sm font-medium text-white border-b border-white pb-0.5'
                  : 'text-sm font-medium text-navy-300 hover:text-white transition-colors'
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a
            href="https://admin.boligflow.toragroup.dk"
            className="text-sm font-medium text-navy-300 hover:text-white transition-colors"
          >
            Log ind
          </a>
          <a
            href="https://admin.boligflow.toragroup.dk"
            className="bg-white text-navy-950 text-sm font-semibold px-4 py-2 rounded-lg hover:bg-cream transition-colors"
          >
            Kom i gang
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          type="button"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-navy-900 px-6 pb-6 space-y-4">
          {links.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              className="block text-navy-200 hover:text-white py-2 text-sm font-medium transition-colors"
            >
              {label}
            </NavLink>
          ))}
          <a
            href="https://admin.boligflow.toragroup.dk"
            className="block bg-white text-navy-950 text-sm font-semibold px-4 py-2 rounded-lg text-center"
          >
            Kom i gang
          </a>
        </div>
      )}
    </header>
  )
}
